import { Document, Page, Text, View, Image, Font } from "@react-pdf/renderer";
import { styles } from "./style";
import { decrypt } from "../../utils";
import moment from "moment";
import { SafeImage } from "../Form8615Pdf";

export const TaskReportPdf = ({ data, dateRange, allSignature, imageMap  }) => {

  Font.register({
    family: "Helvetica",
    fonts: [
      {
        src: "Helvetica",
      },
    ],
  });

  Font.register({
    family: "Island Moments",
    fonts: [
      {
        src: "/assets/fonts/IslandMoments-Regular.ttf",
      },
    ],
  });

  // Helper function to format date
  const formatDate = (dateString) => {
    const date = new Date(dateString);
    return date.toLocaleDateString("en-US", {
      month: "2-digit",
      day: "2-digit",
      year: "numeric",
    });
  };

  // Helper function to format time
  const formatTime = (timeString) => {
    if (!timeString) return "";
    return timeString;
  };

  // Get facility name (assuming all entries have same facility)
  const facilityName = data?.[0]?.facility?.name || "None";

  // Get report date
  const reportDate = `(${moment(dateRange.start).format(
    "MM/DD/YYYY"
  )} - ${moment(dateRange.end).format("MM/DD/YYYY")})`;

  return (
    <Document>
      <Page size="A4" style={styles.coverPage}>
        <View style={styles.coverWrapper}>
          <Image
            src="/assets/images/task-report-cover.png"
            style={styles.coverBg}
            alt="Task Report Cover"
          />

          {/* Overlay Text */}
          <View style={styles.coverContent}>
            <View style={styles.coverFacility}>
              <Text style={styles.coverFacilityLabel}>Facility:</Text>
              <Text style={styles.coverFacilityName}>{facilityName}</Text>
            </View>
            <View style={styles.coverFacility}>
              <Text style={styles.coverFacilityLabel}>Report Date:</Text>
              <Text style={styles.coverFacilityName}>{reportDate}</Text>
            </View>
          </View>
        </View>
      </Page>

      <Page size="A4" style={styles.page}>
        <View style={styles.header}>
          <Image src="/assets/images/logo2.png" style={styles.logo} alt="logo" />
          <Text style={styles.reportTitle}>REPORT</Text>
          <Text style={styles.reportPeriod}>{reportDate}</Text>
          <Text style={styles.entryCount}>{data.length} Task Entries</Text>
        </View>

        {data &&
          data?.map((task, taskIndex) => (
            <View key={taskIndex} style={styles.contentBox}>
              <View style={styles.clientBar}>
                <Text style={styles.clientInfo}>
                  Client: {decrypt(task?.client?.name) || "N/A"}
                </Text>
                <Text style={styles.dateInfo}>
                  ({formatDate(task?.dateTime)})
                </Text>
              </View>

              {/* Task Type and Fields */}
              <View style={styles.cardContainer}>
                {task?.taskType?.subTasks?.map((subTask, subIndex) => (
                  <View key={subIndex} style={styles.card}>
                    <View style={styles.cardHeader}>
                      <Text style={styles.cardTitle}>
                        {subTask?.task?.name || "Task"}
                      </Text>
                    </View>
                    <View style={styles.cardBody}>
                      {subTask?.fields?.map((field, fieldIndex) => {
                        const fieldDone = task?.fieldsDone?.find(
                          (fd) => fd.field?._id === field._id
                        );
                        const isChecked = !!fieldDone;

                        return (
                          <View key={fieldIndex}>
                            <View style={styles.checkItem}>
                              <View
                                style={[
                                  styles.checkbox,
                                  isChecked && styles.checked,
                                ]}
                              >
                                {isChecked && (
                                  <Image
                                    src="/assets/images/check-icon.png"
                                    style={styles.checkmark}
                                    alt="Checkmark"
                                  />
                                )}
                              </View>
                              <Text
                                style={[
                                  styles.itemText,
                                  isChecked && styles.checkedText,
                                ]}
                              >
                                {field?.name || "N/A"}
                              </Text>
                            </View>
                            {fieldDone?.textField && (
                              <Text style={styles.checkedItemDis}>
                                {fieldDone?.textField || "N/A"}
                              </Text>
                            )}
                            {fieldDone?.textEntries &&
                              fieldDone?.textEntries?.map(({ text, _id }) => (
                                <Text style={styles.checkedItemDis} key={_id}>
                                  {text || "N/A"}
                                </Text>
                              ))}
                          </View>
                        );
                      })}
                    </View>
                  </View>
                ))}
              </View>

              {/* Comments Section */}
              {task?.comments && task?.comments.length > 0 && (
                <View style={styles.commentsSection}>
                  <View style={styles.commentsHeader}>
                    <Text>Comments</Text>
                  </View>
                  {task?.comments?.map((comment, commentIndex) => {
                    return (
                      <>
                        <View key={commentIndex} style={styles.comment}>
                          <Text style={styles.commentAuthor}>
                            {comment?.staff?.name || "Staff"} -{" "}
                            {moment(comment.date).format("MM/DD/YYYY hh:mm A")}
                          </Text>
                          <Text style={styles.commentText}>
                            {comment?.comment || "N/A"}
                          </Text>
                        </View>
                      </>
                    );
                  })}
                </View>
              )}

              {task?.fieldsDone &&
                task?.fieldsDone
                  ?.filter(
                    (fd, index, self) =>
                      fd?.staff &&
                      self.findIndex(
                        (x) => x?.staff?._id === fd?.staff?._id
                      ) === index
                  )
                  ?.map(({ shift, staff }) => {
                    const sig = allSignature?.find(
                      (signatureItem) =>
                        signatureItem.staff === staff?._id ||
                        signatureItem.admin === staff?._id
                    );
                    return (
                      <View style={styles.lastSection}>
                        {shift && (
                          <View style={styles.shiftInfo}>
                            <Text style={styles.staffAndShiftLabel}>
                              Shift:
                            </Text>
                            <Text style={styles.staffName}>{shift || "-"}</Text>
                          </View>
                        )}
                        {staff && (
                          <View style={styles.staffInfo}>
                            <Text style={styles.staffAndShiftLabel}>
                              Staff:
                            </Text>
                            <Text style={styles.staffName}>
                              {staff?.name || ""}
                            </Text>
                            {sig?.signature ? (
                              <View style={styles.signature}>
                                <SafeImage
                                  src={decrypt(sig?.signature) || sig?.signature}
                                  style={{ width: 100 }}
                                  alt="signature"
                                  imageMap={imageMap}
                                />
                              </View>
                            ) : sig?.signatureImage ? (
                              <View style={styles.signature}>
                                <SafeImage
                                  src={decrypt(sig?.signatureImage) || sig?.signatureImage}
                                  style={{ width: 100 }}
                                  alt="signature"
                                  imageMap={imageMap}
                                />
                              </View>
                            ) : sig?.signatureText ? (
                              <View style={styles.signature}>
                                <Text style={styles.sigText}>
                                  {sig?.signatureText || ""}
                                </Text>
                              </View>
                            ) : null}
                          </View>
                        )}
                      </View>
                    );
                  })}

              {/* Additional Info */}
              {/* {(task?.timeIn || task?.timeOut || task?.site || task?.placeOfService) && (
              <View style={styles.additionalInfo}>
                {task?.site && (
                  <Text style={styles.infoText}>Site: {task?.site}</Text>
                )}
                {task?.timeIn && (
                  <Text style={styles.infoText}>Time In: {formatTime(task?.timeIn)}</Text>
                )}
                {task?.timeOut && (
                  <Text style={styles.infoText}>Time Out: {formatTime(task?.timeOut)}</Text>
                )}
                {task?.placeOfService && (
                  <Text style={styles.infoText}>Place of Service: {task?.placeOfService}</Text>
                )}
              </View>
            )} */}
            </View>
          ))}
      </Page>
    </Document>
  );
};
